<template>
  <div class="cart">
    <!-- Shop by category section -->
    <div class="wrapper-content">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>My Cart</h2>
          <!-- <p><a href="product.php">Home</a> / <a href="product-detail.php">Vegetable & Fruits</a> / Orange</p> -->
        </div>
      </div>

      <!-- delivery schedule -->
      <div class="container shoppingCartPage">
        <div class="row">
          <div class="col-lg-8 col-md-7 cartListingBlock">
            <div class="product-right">
              <div class="cartListing panel" v-if="productsAdded==null">
                <h4 class="text-center m-5">Cart is empty</h4>
              </div>
              <div
                class="cartListing panel"
                v-for="(product,index) in productsAdded"
                :key="index"
                v-else
              >
                <div class="cartPro">
                  <div class="proImgCart">
                    <a href="#" class>
                      <img :src="imageBaseUrl+product.items.image" alt="cream" />
                    </a>
                  </div>
                  <div class="proTextCart">
                    <h4>
                      <a href="#">{{product.items.name}}</a>
                    </h4>
                    <p class="proQuantityPrice">
                      1/packet
                      <span>{{currency}}{{product.items.mrp_single*product.quantity}}</span>
                    </p>
                    <div class="quantityField">
                      <div class="quantity">
                        <div class="qty_dv">
                          <b-input-group>
                            <b-input-group-prepend>
                              <b-btn
                                variant="info"
                                v-on:click="decrement('index_'+index,product.items.id)"
                              >-</b-btn>
                            </b-input-group-prepend>

                            <b-form-input
                              type="number"
                              :id="'index_'+index"
                              :value="product.quantity"
                            ></b-form-input>

                            <b-input-group-append>
                              <b-btn
                                variant="info"
                                @click="increment('index_'+index,product.items.id)"
                              >+</b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </div>
                      </div>
                      <div class="remove" v-on:click="deleteItem()">
                        <vue-material-icon name="delete" :size="28"></vue-material-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-5 cartListingOption">
            <div class="product-right">
              <div class="subscribe_bx">
                <div class="border listbox panel">
                  <div class="row">
                    <div class="col-md-12">
                      <h4 @click="$bvModal.show('addDeliveryAddress')" class="addressSelectBtn">
                        Select Delivery Address
                        <img
                          class="nextIconImg"
                          src="../assets/images/next.svg"
                        />
                      </h4>
                      <p>{{selectAddress}}</p>

                      <b-modal id="newAddress" hide-footer>
                        <template v-slot:modal-title>
                          New Address
                          <div class="addNewAddress">
                            <button
                              class="btn btn-primary"
                              @click="$bvModal.show('newAddress')"
                            >Add New Address</button>
                          </div>
                        </template>
                      </b-modal>

                      <b-modal id="addDeliveryAddress" hide-footer>
                        <template v-slot:modal-title>
                          Delivery Address
                          <div class="addNewAddress">
                            <router-link
                              to="/add-new-address"
                              class="btn btn-primary"
                            >Add New Address</router-link>
                          </div>
                        </template>

                        <div class="deliveryAddressList">
                          <ul>
                            <li v-for="(item,index) in addresses" :key="index">
                              <div class="radiobtn">
                                <input
                                  type="radio"
                                  name="selectAddress"
                                  v-model="selectAddress"
                                  :value="item.address.address"
                                />
                                <label
                                  for="homeAddress"
                                  @click="$bvModal.hide('addDeliveryAddress')"
                                >
                                  <h5>{{item.address.title}}</h5>
                                  <p>{{item.address.address}}</p>
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </b-modal>
                    </div>
                  </div>
                </div>
                <div class="border listbox panel">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="selectDatePicker">
                        <h4>Select Delivery Date</h4>
                        <p>{{ showDateModal | moment("DD MMM, YYYY") }}</p>
                        <datepicker ref="programaticOpen" v-model="showDateModal"></datepicker>
                        <button class="calendarBtn" @click="openPicker">
                          <i class="fa fa-calendar"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="border listbox panel">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="modalLink" v-b-modal.selectTimeModal>
                        <h4>Select Delivery Time</h4>
                        <span class="clockIcon">
                          <img src="../assets/images/fast.svg" />
                        </span>
                      </div>
                      <p>Evening (8:40 PM - 11:44 PM)</p>
                    </div>
                    <b-modal id="selectTimeModal" hide-footer>
                      <template v-slot:modal-title>Select Delivery Timing</template>
                      <ul class="deliveryTimingList">
                        <li>
                          <div class="radioBtn">
                            <input type="radio" name="DeliveryTIme" id="noon" />
                            <label
                              for="noon"
                              @click="$bvModal.hide('selectTimeModal')"
                            >Noon (9:10 AM - 5:00 PM)</label>
                          </div>
                        </li>
                        <li>
                          <div class="radioBtn">
                            <input type="radio" name="DeliveryTIme" id="morning" />
                            <label
                              for="morning"
                              @click="$bvModal.hide('selectTimeModal')"
                            >Morning (9:10 AM - 5:00 PM)</label>
                          </div>
                        </li>
                      </ul>
                    </b-modal>
                  </div>
                </div>

                <div class="TotalCheckout panel">
                  <div class="total_amt">
                    Total Amount
                    <span>{{currency}} {{totalAmount}}</span>
                  </div>
                  <div class="btn_rw">
                    <router-link class="btn btn-primary full" to="/payment-method">Place Order</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { getBalanceAndDeliveryInfo } from "./../services/api";
export default {
  name: "product",
  components: {
    Datepicker
  },
  data() {
    return {
      currency: localStorage.getItem("CurrencySymbol"),

      disabledDates: {},
      showDateModal: null,
      productsAdded: [],
      quantity: "",
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      options: [
        { text: "Home", value: "home" },
        { text: "Work", value: "work" },
        { text: "Other", value: "other" }
      ],
      addresses: [],
      selectAddress: ""
    };
  },
  created() {
    this.getList();
    this.getOrderInfo();
  },
  computed: {
    totalAmount() {
      var total = 0;
      for (var i = 0; i < this.productsAdded.length; i++) {
        total +=
          this.productsAdded[i].items.mrp_single *
          this.productsAdded[i].quantity;
      }
      return total;
    }
  },
  methods: {
    getOrderInfo() {
      var requestData = {
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        vendor_id: localStorage.getItem("vendorId")
      };

      getBalanceAndDeliveryInfo(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            console.log(result);
            this.addresses = result.data.addresses;
            // this.delivery_id = result.data.deliver_schdule_id;
            // this.orderChangeDate = result.data.edit__order_time;
            // this.amountBilled = result.data.subscriptionOrderTotalPrice;
            // this.nextDeliveryDate =
            //   result.data.willDeliver +
            //   " " +
            //   result.data.subscriptionItems[0].between;
            // this.subscribedItems = result.data.subscriptionItems;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },
    openPicker() {
      this.$refs.programaticOpen.showCalendar();
    },
    getList() {
      this.productsAdded = JSON.parse(localStorage.getItem("selectedProduct"));
    },
    deleteItem(index) {
      this.productsAdded.splice(index, 1);

      localStorage.setItem(
        "selectedProduct",
        JSON.stringify(this.productsAdded)
      );
    },
    increment(idx, id) {
      var value = parseInt(document.getElementById(idx).value, 10);
      value = isNaN(value) ? 0 : value;
      if (value < 10) {
        value++;
        document.getElementById(idx).value = value;
      }
      var b = this.productsAdded.filter(item => item.items.id == id);

      b[0].quantity = value;
      localStorage.setItem(
        "selectedProduct",
        JSON.stringify(this.productsAdded)
      );
    },
    decrement(idx, id) {
      var value = parseInt(document.getElementById(idx).value, 10);
      value = isNaN(value) ? 0 : value;
      if (value > 1) {
        value--;
        document.getElementById(idx).value = value;
      }
      var b = this.productsAdded.filter(item => item.items.id == id);

      b[0].quantity = value;
      localStorage.setItem(
        "selectedProduct",
        JSON.stringify(this.productsAdded)
      );
    }
  }
};
</script>
